// Module
var code = "<h2 id=\"glossary-of-financial-aid-terms\">Glossary of Financial Aid Terms</h2> <p>Find out the definitions of terms you may read online or in materials relating to student aid and financial assistance.</p> ";
// Exports
export default code;